import { render, staticRenderFns } from "./SimularQuitacaoDialog.vue?vue&type=template&id=a20dd9ca"
import script from "./SimularQuitacaoDialog.vue?vue&type=script&lang=js"
export * from "./SimularQuitacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./SimularQuitacaoDialog.vue?vue&type=style&index=0&id=a20dd9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports